//
// Copyright 2025 DXOS.org
//

import { TypeOptions } from '@dxos/app-toolkit';

export type TypeInputOptions = TypeOptions.TypeInputOptions;
export const TypeInputOptionsAnnotation = TypeOptions.TypeInputOptionsAnnotation;
export const TypeInputOptionsAnnotationId = TypeOptions.TypeInputOptionsAnnotationId;
